import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { CoachingNamedItem } from '@euler/model/coaching';
import { memo } from 'react';
import { Pressable, ScrollView } from 'react-native';

/** The first-level categories as one row; null picks them all. */
export const CategoryChips = memo(
  ({
    categories,
    selected,
    total,
    onSelect,
  }: {
    categories: CoachingNamedItem[];
    selected: string | null;
    total: number | null;
    onSelect: (slug: string | null) => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const items = [
      { slug: null, name: total == null ? '全部' : `全部 ${total}` },
      ...categories,
    ];
    return (
      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={{ gap: rpx(8), paddingHorizontal: rpx(16) }}
      >
        {items.map(item => {
          const on = item.slug === selected;
          return (
            <Pressable
              key={item.slug ?? 'all'}
              onPress={() => onSelect(item.slug)}
              accessibilityRole="button"
              accessibilityState={{ selected: on }}
              style={{
                borderRadius: rpx(999),
                borderWidth: 1,
                borderColor: on ? aiColors.primary : aiColors.border,
                backgroundColor: on ? aiColors.primary : aiColors.card,
                paddingHorizontal: rpx(12),
                paddingVertical: rpx(6),
              }}
            >
              <Typography.Text
                size={rpx(12)}
                medium
                color={on ? aiColors.primaryForeground : aiColors.foreground}
              >
                {item.name}
              </Typography.Text>
            </Pressable>
          );
        })}
      </ScrollView>
    );
  },
);
